'use strict';

var TDChartTodAggregationFactory = function TDChartTodAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  function TDChartTodAggregation() {
    DataAggregationFactory.call(this, 'service', 'thematic-demand-chart-service-time-of-day');
  }
  TDChartTodAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartTodAggregation.constructor = TDChartTodAggregation;
  TDChartTodAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedTOD = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedTOD[data[index].departureDateMomentTimeOfDay])) {
        aggregatedTOD[data[index].departureDateMomentTimeOfDay].push(data[index]);
      } else {
        aggregatedTOD[data[index].departureDateMomentTimeOfDay] = [data[index]];
      }
    }
    keys = Object.keys(aggregatedTOD);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      metricKeys = ExtractMetricKeysService.extract(aggregatedTOD[keys[index]][0]);
      aggregationFunction(aggregatedTOD[keys[index]], metricKeys, reducedEntry);
      aggregatedTOD[keys[index]] = reducedEntry;
    }
    function parseTOD(TOD) {
      var rangeTOD = TOD.split('-');
      return Date.parse('01/01/1970 ' + rangeTOD[0]);
    }
    return this.sortAggregationResults(aggregatedTOD, parseTOD);
  };
  return TDChartTodAggregation;
};
TDChartTodAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = TDChartTodAggregationFactory;